import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';

export const WeaponBaseballBat: WeaponDefinition = {
  id: 'baseballBat',
  name: 'Baseball Bat',
  icon: 'bball.1.png',
  category: 'melee',
  maxAmmo: 10,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: false,
  allowRetreat: true,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, world, angle } = ctx;

    const batRange = 30;
    const batDamage = 30;
    const knockback = 400;

    const wormCenter = worm.getCenterPosition();

    const rad = (angle * Math.PI) / 180;
    const aimRad = worm.facing === 'right' ? rad : Math.PI - rad;

    const swingX = wormCenter.x + Math.cos(aimRad) * (batRange / 2);
    const swingY = wormCenter.y - Math.sin(aimRad) * (batRange / 2);

    const hitWorms = [];

    for (const target of world.getWorms()) {
      if (target.id === worm.id) continue;
      if (target.state === 'dead') continue;

      const targetCenter = target.getCenterPosition();
      const dx = targetCenter.x - swingX;
      const dy = targetCenter.y - swingY;
      const dist = Math.sqrt(dx * dx + dy * dy);

      if (dist < batRange) {
        const pushX = Math.cos(aimRad) * knockback;
        const pushY = -Math.sin(aimRad) * knockback - 100;

        target.addPendingDamage(batDamage);
        target.applyExplosionPush(pushX, pushY);
        hitWorms.push(target);
      }
    }

    return {
      success: true,
      entities: [],
      message: hitWorms.length > 0 ? `Home run! Hit ${hitWorms.length}` : 'Strike!',
      hitWorms,
    };
  },
};
